export const AUTHENTICATION = "AUTHENTICATION";
export const USER_DATA = "USER_DATA";
export const VIEW_SETTING = "VIEW_SETTING";
export const UPDATE_GRAPHS_STATE = "UPDATE_GRAPHS_STATE";
export const LOADING = "LOADING";
